/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clock: NonNullable<unknown> }} Workout_Live_Paused_ForInputs */

const en_us2_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paused for ${i?.clock}`)
};

const pt_br2_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pausado há ${i?.clock}`)
};

const es_419_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En pausa desde hace ${i?.clock}`)
};

const pt_pt2_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Em pausa há ${i?.clock}`)
};

const fr_fr2_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En pause depuis ${i?.clock}`)
};

const de_de2_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pausiert: ${i?.clock}`)
};

const it_it2_workout_live_paused_for = /** @type {(inputs: Workout_Live_Paused_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In pausa da ${i?.clock}`)
};

/**
* | output |
* | --- |
* | "Paused for {clock}" |
*
* @param {Workout_Live_Paused_ForInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_paused_for = /** @type {((inputs: Workout_Live_Paused_ForInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Paused_ForInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_paused_for(inputs)
	if (locale === "es-419") return es_419_workout_live_paused_for(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_paused_for(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_paused_for(inputs)
	if (locale === "de-DE") return de_de2_workout_live_paused_for(inputs)
	if (locale === "it-IT") return it_it2_workout_live_paused_for(inputs)
	return en_us2_workout_live_paused_for(inputs)
});
export { workout_live_paused_for as "workout-live.paused_for" }